export default __webpack_public_path__ + "static/media/DOPPLE-UST-LP.a7d280cb.png";